import { Button, type ButtonProps } from '@mui/material';
import NextLink from 'next/link';
import type { ReactNode } from 'react';
import { AnalyticsEvent, useTrackEvent } from '$analytics';

export function RequestNewButton({
  children,
  ...buttonProps
}: {
  children?: ReactNode;
} & Omit<ButtonProps, 'href' | 'onClick' | 'LinkComponent'>) {
  const trackEvent = useTrackEvent();

  return (
    <Button
      LinkComponent={NextLink}
      href="/onboarding/user/new"
      variant="outlined"
      color="utility"
      sx={{ flex: 1, minWidth: '140px' }}
      onClick={() => trackEvent(AnalyticsEvent.AddTeamMemberCardButtonClick)}
      {...buttonProps}
    >
      {children ?? 'Add Team Member'}
    </Button>
  );
}
